/**
 * @generated SignedSource<<c3e989084016a218ada3e8ea98bbbb61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MergeRulesInputObject = {
  excludeTxnIds?: ReadonlyArray<string> | null | undefined;
  matchKind?: string | null | undefined;
  overrideTxnIds?: ReadonlyArray<string> | null | undefined;
  regex?: string | null | undefined;
  ruleIds: ReadonlyArray<string>;
};
export type similarityPage_MergeRulesMutation$variables = {
  input: MergeRulesInputObject;
};
export type similarityPage_MergeRulesMutation$data = {
  readonly mergeRules: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type similarityPage_MergeRulesMutation = {
  response: similarityPage_MergeRulesMutation$data;
  variables: similarityPage_MergeRulesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "similarityPage_MergeRulesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MergeRulesMutationPayload",
        "kind": "LinkedField",
        "name": "mergeRules",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "similarityPage_MergeRulesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MergeRulesMutationPayload",
        "kind": "LinkedField",
        "name": "mergeRules",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "45281138145a8fe5bec50ab157b5ad5c",
    "id": null,
    "metadata": {},
    "name": "similarityPage_MergeRulesMutation",
    "operationKind": "mutation",
    "text": "mutation similarityPage_MergeRulesMutation(\n  $input: MergeRulesInputObject!\n) {\n  mergeRules(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4ea9523c72ea6650fbd49dccdc85691";

export default node;
